import { defineStore } from 'pinia'
import { fetchMyModules, activateModuleCode } from '@/api/moduleApi'
import tokenService from '@/utils/tokenService'
import { USER_ROLE_ADMIN } from '@/constants/userRole'

export const useModuleStore = defineStore('module', {
  state: () => ({
    moduleCodes: [],
    modules: [],
    loaded: false,
    loading: false,
    activationModalVisible: false,
    activationTarget: null
  }),

  getters: {
    hasModule: (state) => (moduleCode) => {
      if (!moduleCode) return true
      const role = tokenService.getUserRoleFromToken()
      if (role === USER_ROLE_ADMIN) return true
      return state.moduleCodes.includes(moduleCode)
    }
  },

  actions: {
    async fetchModules(force = false) {
      if (!tokenService.hasAccessToken()) {
        this.moduleCodes = []
        this.modules = []
        this.loaded = true
        return
      }
      if (this.loading) return
      if (this.loaded && !force) return
      this.loading = true
      try {
        const data = await fetchMyModules()
        this.moduleCodes = data?.moduleCodes || []
        this.modules = data?.modules || []
        this.loaded = true
      } catch (error) {
        console.error('加载功能模块失败', error)
        this.moduleCodes = []
        this.modules = []
      } finally {
        this.loading = false
      }
    },

    reset() {
      this.moduleCodes = []
      this.modules = []
      this.loaded = false
      this.activationModalVisible = false
      this.activationTarget = null
    },

    openActivationModal(target = null) {
      this.activationTarget = target
      this.activationModalVisible = true
    },

    closeActivationModal() {
      this.activationModalVisible = false
      this.activationTarget = null
    },

    async activateCode(code, targetModuleCode = null) {
      const data = await activateModuleCode(code, targetModuleCode || undefined)
      this.moduleCodes = data?.moduleCodes || this.moduleCodes
      this.modules = data?.modules || this.modules
      this.loaded = true
      return data
    }
  }
})
